import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';

interface ContainerProps{
    showModal: boolean;
  }

export const Container = styled.div<ContainerProps>`
    position: absolute;
    display: flex;
    align-items: center;

    position: fixed;
    overflow: hidden;

    
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    z-index: 3;

    background-color: rgba(0, 0, 0, 0.5);

${
  props =>
    !props.showModal &&
    css`
    display: none;
    `
}

#ModalHistoric {
    margin: auto;
    display: flex;
    flex-direction: column;
    border-radius: 2.0rem;
    background-color: ${theme.colors.background};
    border: 1.5px solid ${theme.colors.borderColor};

    height: auto;
    width: 70%;
    height: 70%;
    position: relative;
    align-items: center;
    overflow-y: auto;

    padding: 3rem 5rem;

    #button{
     justify-content:center ;
      display: flex;
      width:10%;
      height: 65%;
      
    }
}
h3{
      color: ${theme.colors.blueMain};
      font-weight: bold;
      padding: 3rem 7rem;
    }
`;
